import http from './request'

export const getShortParam = (data) => {
  return http({
    url: '/promotion/urlParamMapper/getShortParam',
    method: 'POST',
    data
  })
}

// 获取分享信息
export const getShareTemplateInfo = (data) => {
  return http({
    url: '/promotion/auth/appShareConfig/getTemplateInfo',
    method: 'POST',
    data
  })
}

export const coinWithdraw = (data) => {
  return http({
    url: '/promotion/CoinWithdraw/withdraw',
    method: 'POST',
    data
  })
}


// 获取网友助力用户信息
export const getNetFriend = (data) => {
  return http({
    url: '/promotion/CoinNetFriend/getInfo',
    method: 'POST',
    data
  })
}

// 获取全局配置（主要是奖池金额）
export const getGlobalConfig = (data) => {
  return http({
    url: '/promotion/CoinGlobalConfig/getConfig',
    method: 'POST',
    data
  })
}

// 查询是否存在web用户
export const getWebUserInfo = (data) => {
  return http({
    url: '/user/WebUser/getWebUserInfo',
    method: 'POST',
    data
  })
}

// 查询web用户信息
export const getInfoOfWeb = (data) => {
  return http({
    url: '/user/WebUser/getInfo',
    method: 'POST',
    data
  })
}

// 推金币code打标
export const setCodeSource = (data) => {
  return http({
    url: '/promotion/CoinUser/setCodeSource',
    method: 'POST',
    data
  })
}

// 获取限时福利
export const coinTimeLimitedOffer = (data) => {
  return http({
    url: '/promotion/CoinTimeLimitedOffer/receive',
    method: 'POST',
    data
  })
}
// 获取任务列表
export const coinTaskGetList = (data) => {
  return http({
    url: '/promotion/CoinTask/getList',
    method: 'POST',
    data
  })
}
// 获取提现记录列表
export const coinWithdrawGetPagedList = (data) => {
  return http({
    url: '/promotion/CoinWithdraw/getPagedList',
    method: 'POST',
    data
  })
}
// 上报助力
export const coinNetFriendHelp = (data) => {
  return http({
    url: '/promotion/CoinNetFriend/help',
    method: 'POST',
    data
  })
}
// 获取助力记录
export const getHelpRecords = (data) => {
  return http({
    url: '/promotion/CoinNetFriend/getHelpRecords',
    method: 'POST',
    data
  })
}

export const getParam = (data) => {
  return http({
    url: `/bizBase/ShareLink/getParam`,
    method: 'post',
    data
  })
}

// 获取任务列表
export const coinListTask = (data) => {
  return http({
    url: '/promotion/CoinTask/listTask',
    method: 'POST',
    data
  })
}

// 领取任务
export const acceptTask = (data) => {
  return http({
    url: '/promotion/CoinTask/acceptTask',
    method: 'POST',
    data
  })
}

// 领取任务奖励
export const receiveReward = (data) => {
  return http({
    url: '/promotion/CoinTask/receiveReward',
    method: 'POST',
    data
  })
}

// 完成任务（只限广告任务和曝光任务）
export const finishTask = (data) => {
  return http({
    url: '/promotion/CoinTask/finishTask',
    method: 'post',
    data
  })
}

// 验证任务
export const verifyTask = (data) => {
  return http({
    url: '/promotion/CoinTask/verify',
    method: 'post',
    data
  })
}

// 加倍提现卡
export const doubleWithdraw = (data) => {
  return http({
    url: '/promotion/CoinLottery/doubleWithdraw',
    method: 'post',
    data
  })
}
// 获取银行卡信息
export const getBankAccountInfo = (data) => {
  return http({
    url: '/payCenter/BankAccount/getBankAccountInfo',
    method: 'post',
    data
  })
}

// 领取加倍后道具奖励
export const receivePrizeBalance = (data) => {
  return http({
    url: '/promotion/CoinLottery/receivePrizeBalance',
    method: 'post',
    data
  })
}
// 添加银行卡
export const saveBankAccount = (data) => {
  return http({
    url: '/payCenter/BankAccount/saveBankAccount',
    method: 'post',
    data
  })
}

// 获取taurus中转页链接
export const getTaurusLink = (data) => {
  return http({
    url: '/bizBase/ShareLink/getTaurusLink',
    method: 'post',
    data
  })
}

// 获取助力统计
export const getPagedHelpStatistics = (data) => {
  return http({
    url: '/promotion/CoinNetFriend/getPagedHelpStatistics',
    method: 'post',
    data
  })
}

// 更新用户第三方信息
export const updateUserInfo = (data) => {
  return http({
    url: '/user/UserThirdInfo/updateInfo',
    method: 'post',
    data
  })
}

// 推金币-查询bank提现记录
export const getBankWithdrawRecordPagedList = (data = {
  recordType: 'WITHDRAW',
  pageNum: 1,
  pageSize: 1,
}) => {
  return http({
    url: '/promotion/CoinWithdraw/getBankWithdrawRecordPagedList',
    method: 'post',
    data
  })
}
